// extracted by mini-css-extract-plugin
export default {"SendError":"EducationExpense_SendError__tgPrz","ButtonContainer":"EducationExpense_ButtonContainer__ZCbua"};